import { css, SerializedStyles } from '@emotion/core';
import { Theme } from './theme';

// Typography mixins based on Material UI Type Scale System:
// https://material.io/design/typography/#type-scale

export const normalText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.body1}
  color: ${theme.mui.palette.text.primary};
  font-size: 1.6rem;
`;

export const secondaryText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.body1}
  font-size: 1.4rem;
`;

export const helpText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.body1}
  color: ${theme.mui.palette.text.primary};
  font-size: 1.2rem;
`;

export const titleText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.h5}
  font-weight: 700;
  color: #0f2233;
  font-size: 2.8rem;
`;

export const promoText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.h5}
  font-weight: 700;
  font-size: 3.2rem;
  color: ${theme.mui.palette.text.primary};
`;

export const subtitleText = (theme: Theme): SerializedStyles => css`
  ${theme.mui.typography.subtitle1}
`;

export const inlineButton = (theme: Theme): SerializedStyles => css`
  ${secondaryText(theme)}
  font-size: inherit;
  color: ${theme.mui.palette.primary.main};
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: ${theme.mui.typography.fontWeightBold};
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding: 0px;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-thickness: 2px;
  }
  &:active {
    text-decoration: none;
  }
`;

// Shadow mixins:

export const shadowFrame = (): SerializedStyles => css`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16), 0px 0px 2px rgba(0, 0, 0, 0.08);
`;
export const shadowFrameSelected = (): SerializedStyles => css`
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16), 0px 0px 2px rgba(0, 0, 0, 0.08);
`;

export const shadowTop = (): SerializedStyles => css`
  box-shadow: 0px -16px 16px -16px rgba(0, 0, 0, 0.08),
    0px -6px 6px -6px rgba(0, 0, 0, 0.16);
`;
